"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 2px 2px 0 0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 1px 1px rgba(0, 0, 0, 0.16);\n  line-height: 0px !important;\n  background-color: #fff;\n\n  .__canner-editor_topToolbarItem,\n  .__canner-editor_topToolbarItemActive {\n    display: block;\n    width: 25px;\n    margin: 10px;\n    text-align: center;\n    float: none;\n  }\n\n  .__canner-editor_topToolbarItemDisabled > * {\n    stroke: #ccc !important;\n    cursor: not-allowed;\n  }\n\n  .qlStroke {\n    stroke: #444;\n    fill: transparent;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n\n  .qlStrokeActive {\n    stroke: #4f748e;\n    fill: transparent;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-width: 2;\n  }\n\n  .qlStrokeMitter {\n    stroke: #444;\n    fill: transparent;\n  }\n\n  .qlStrokeMitterActive {\n    stroke: #4f748e;\n    fill: transparent;\n  }\n\n  .qlFill {\n    fill: #444;\n  }\n\n  .qlFillActive {\n    fill: #4f748e;\n  }\n\n  .qlEven {\n    stroke: #444;\n    fill: #fff;\n  }\n\n  .qlEvenActive {\n    stroke: #4f748e;\n    fill: #fff;\n  }\n\n  .qlColorLabel {\n    fill: red;\n  }\n\n  .qlTransparent {\n    opacity: 0.2;\n  }\n\n  .qlThin {\n    stroke: #444;\n    fill: transparent;\n    stroke-width: 1;\n  }\n\n  .qlThinActive {\n    stroke: #4f748e;\n    fill: transparent;\n    stroke-width: 1;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents.default.div(_templateObject());

exports.Container = Container;